'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';

import { upsertMoengageClickIds } from '@/utils/moengage';
import { setUtmParams } from '@/utils/utils';

const UtmHandlerInner = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (searchParams) {
      setUtmParams(searchParams);

      // Capture click IDs for retargeting cohorts (overwrite on new campaign).
      const gclid = searchParams.get('gclid') || '';
      const fbclid = searchParams.get('fbclid') || '';
      if (gclid || fbclid) {
        upsertMoengageClickIds({ gclid, fbclid });
      }
    }
  }, [searchParams]);

  return null;
};

const UtmHandler = () => {
  return (
    <Suspense fallback={null}>
      <UtmHandlerInner />
    </Suspense>
  );
};

export default UtmHandler;
